/**
 * The "Til baka" pill after a connector jump (ViewerChrome BackPill): it goes away after 4 s on every
 * device. iPads and landscape show the big pill; a phone held upright gets one half the size, because
 * the big one covers too much of a small screen (pure parts unit tested).
 */
import { useMediaQuery } from '../lib/useMediaQuery';

/** A phone held upright: narrower than Tailwind's `sm` (an iPad never is, even in split view portrait). */
export const PHONE_PORTRAIT_QUERY = '(max-width: 639px) and (orientation: portrait)';
/** How long the pill stays after a jump (every device). */
export const BACK_PILL_MS = 4000;

/** Whether the window is a phone held upright (PHONE_PORTRAIT_QUERY), following rotation. */
export function usePhonePortrait(): boolean {
  return useMediaQuery(PHONE_PORTRAIT_QUERY);
}
